
    
      <app-kontable
        title="{{ 'promotion.touchPointsSelected' | translate }}"
        [columns]="['id', 'code', 'description']"
        [titles]="['#', 'promotion.code', 'promotion.description']"
        [source]="selectedTouchPoints"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showEditButton]="false"
        (onRemove)="deleteTouchPoint($event.id)"
        (onAdd)="showDialog()">
      </app-kontable>
      <label class="text-left" style="color: grey; font-style: italic;">
        {{ warningKontable}}
      </label>
      <div class="ui-g-12" style="margin-top: 40px">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          iconPos="left"
          label="{{ 'promotion.saveAll' | translate }}"
          style="float: right"
          (click)="saveAllTouchPoints()">
        </button>
      </div>
      <p-dialog
        *ngIf="showDialog"
        [modal]="true"
        [minWidth]="600"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="display"
        [style]="{width: '500px', height: '500px'}">
        <p-header>
          {{chooseTouchPoints | translate}}
        </p-header>
        <form [formGroup]="form">
          <p-multiSelect
            class="multiselect-container"
            [options]="touchPoints"
            formControlName="touchPoints"
            [filter]="true"
            styleClass="multiselect-fixed-height"
            scrollHeight="350px"
            maxSelectedLabels="3">
          </p-multiSelect>
        </form>
        <p-footer>
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-save"
            iconPos="left"
            label="{{ 'common.reject' | translate }}"
            (click)="this.display = false">
          </button>
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-save"
            iconPos="left"
            label="{{ 'promotion.addAll' | translate }}"
            (click)="addAllTouchPoints(form.controls['touchPoints'].value)">
          </button>
        </p-footer>
      </p-dialog>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/touch-point/tab-touch-point-component.ts.TabTouchPointComponent.html